define([
	"dojo/_base/declare",
	"Apparel/NewProductSourceSamples"
], function(declare,NewProductSourceSamples) {

	return declare(NewProductSourceSamples, {
	    /**
	     * @override
	     * initialize samples form with SupplierRequest
	     */
	    onCreatePopup: function(view) {
	        view.setSupplierRequest(this.widget.getViewNode());
	    },

		/**
		 * @override
		 * add attribute for checking if samples are being created inside SR
		 */
		onCreatePopupParams: function(params) {
			const node = this.getParent();
			if(node.$Type === "SupplierRequest") {
				params.bSupplierRequest = true;
			}
		},

		postProcessSuccess: function() {
			if (this.samples != null && this.samples.length <= this.widget.querySize) {
				this._newPostProcess();
			} else {
				this.widget.refreshData();
			}
		}
	});
});
